import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiSearch, FiVideo, FiCpu } from 'react-icons/fi';
import './Search.css';

const Search = () => {
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get('q') || '';
  const [query, setQuery] = useState(initialQuery);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(!!initialQuery);
  const [aiMode, setAiMode] = useState(true); // По умолчанию ИИ-режим для менеджеров

  useEffect(() => {
    // Если есть query параметр в URL, выполняем поиск автоматически
    if (initialQuery) {
      performSearch(initialQuery);
    }
  }, []);

  const performSearch = async (searchQuery) => {
    if (!searchQuery.trim()) {
      return;
    }

    setLoading(true);
    setSearched(true);

    try {
      let response;
      if (aiMode) {
        // ИИ-диалоговый поиск
        response = await axios.post('/api/search/ai-dialog/', {
          query: searchQuery,
        });
        setResults(response.data.results || []);
      } else {
        // Обычный поиск
        response = await axios.get('/api/search/', {
          params: { q: searchQuery },
        });
        setResults(response.data.results || []);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка поиска');
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    performSearch(query);
  };

  return (
    <div className="search-page">
      <h1>Интеллектуальный поиск</h1>

      <div className="search-mode-toggle">
          <button
            type="button"
            className={`mode-btn ${aiMode ? 'active' : ''}`}
            onClick={() => setAiMode(true)}
          >
            <FiCpu /> ИИ-поиск (диалог)
          </button>
        <button
          type="button"
          className={`mode-btn ${!aiMode ? 'active' : ''}`}
          onClick={() => setAiMode(false)}
        >
          <FiSearch /> Обычный поиск
        </button>
      </div>

      <form onSubmit={handleSearch} className="search-form">
        <div className="search-input-wrapper">
          <FiSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={
              aiMode
                ? 'Например: "найди мне все вебинары за февраль 26 года по филлерам"'
                : 'Введите запрос для поиска вебинаров...'
            }
          />
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Поиск...' : 'Найти'}
          </button>
        </div>
      </form>

      {searched && (
        <div className="search-results">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : results.length > 0 ? (
            <>
              <h2>Найдено результатов: {results.length}</h2>
              <div className="results-grid">
                {results.map((webinar, index) => (
                  <Link
                    key={webinar.id}
                    to={`/webinars/${webinar.id}`}
                    className={`result-card ${index === 0 && webinar.is_most_relevant ? 'most-relevant' : ''}`}
                  >
                    {index === 0 && webinar.is_most_relevant && (
                      <div className="relevant-badge">Наиболее релевантный</div>
                    )}
                    <div className="result-icon">
                      <FiVideo />
                    </div>
                    <div className="result-content">
                      <h3>{webinar.title}</h3>
                      {webinar.speaker_data && (
                        <p className="result-speaker">{webinar.speaker_data.full_name}</p>
                      )}
                      <p className="result-date">
                        {new Date(webinar.recording_date).toLocaleDateString('ru-RU')}
                      </p>
                      <div className="result-stats">
                        <span><FiVideo /> {webinar.views_count} просмотров</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          ) : (
            <div className="empty-state">
              <p>Ничего не найдено</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
